import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Chart } from "react-google-charts";
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import * as UserActions from "../actions/UserActions";

const useStyles = makeStyles((theme) => ({
  root: {
		display: "flex",
		flexDirection: "column",
		padding: 10,
  },
  chart: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: "10px"
  }
}));

const IssueChart = (props) => {
  const classes = useStyles();

  const issues = props.issues;

  const statusOpen = issues.filter(issue => issue.status === "Open").length;
  const statusInProgress = issues.filter(issue => issue.status === "In Progress").length;
  const statusClosed = issues.filter(issue => issue.status === "Closed").length;
  
  const severityMinor = issues.filter(issue => issue.severity === "Minor").length;
  const severityMajor = issues.filter(issue => issue.severity === "Major").length;;
  const severityCritical = issues.filter(issue => issue.severity === "Critical").length;

  return (
    <div className={classes.root}>
      <p>Issues Chart</p>
      <div className={classes.chart}>
        <Chart
          width="80vw"
          chartType="PieChart"
          loader={<div>Loading Chart</div>}
          data={[
            ['Status', 'Counts'],
            ['Open', statusOpen],
            ['In Progress', statusInProgress],
            ['Closed', statusClosed],
          ]}
          options={{
            title: 'Status wise chart',
          }}
          rootProps={{ 'data-testid': '1' }}
        />
        <Chart
          width="80vw"
          chartType="PieChart"
          loader={<div>Loading Chart</div>}
          data={[
            ['Severity', 'Counts'],
            ['Minor', severityMinor],
            ['Major', severityMajor],
            ['Critical', severityCritical],
          ]}
          options={{
            title: 'Severity wise chart',
          }}
          rootProps={{ 'data-testid': '1' }}
        />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
	return {
	  issues: state.issues,
		users: state.users
	};
  }
  
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(IssueActions, dispatch),
		userActions: bindActionCreators(UserActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueChart))
